import { createContext } from 'react'

const orderSearchContext = createContext()

export default orderSearchContext